/* eslint-disable @typescript-eslint/ban-types */
import { identity } from 'fp-ts/function';
/**
 * Converts a given object from a deeply readonly object to a deeply mutable object.
 * This does not change structure of the given object it does only convert the type.
 * Please note that his could be an unsafe operation when the object is given to function that mutates the object. In this case
 * clone the object deeply first.
 */
export var mutableDeep = identity;
